<template>
  <div class="phones-table-wrapper">
    <ul class="phones-table">
      <li
        class="row"
        v-for="phone in phones"
        v-bind:key="phone.name"
      >
        <span class="cell icon">
          <font-awesome-icon v-bind:icon="phone.icon"></font-awesome-icon>
        </span>
        <span class="cell">
          <a v-bind:href="`tel:${phone.number.replace(/ /g, '-')}`">
            <span itemprop="telephone">{{ phone.number }}</span>
          </a>
        </span>
        <span class="cell">{{ phone.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faMobileAlt, faPhoneAlt } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'ContactsPhones',
  components: { FontAwesomeIcon },
  data: function () {
    return {
      phones: [
        {
          number: '+375 162 52-72-40',
          name: '(т/ф)',
          icon: faPhoneAlt
        },
        {
          number: '+375 29 8888-099',
          name: '(мтс)',
          icon: faMobileAlt
        },
        {
          number: '+375 29 908-76-07',
          name: '(velcom)',
          icon: faMobileAlt
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
  .phones-table {
    text-align: left;
    margin: 0 auto;
    display: table;
    a {
      text-decoration: none;
      font-family: "Gotham Pro Regular", $font-stack;
    }

    & > .row {
      display: table-row;
      & > .cell {
        display: table-cell;
        vertical-align: middle;
        padding-bottom: 0.75em;
        padding-right: 0.5em;
        &:last-child { padding-right: 0; }
        &.icon {
          color: $default-link-color;
          text-align: center;
        }
      }
      &:last-child > .cell {
        padding-bottom: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/ContactsPhones.vue